import React from "react";
import { Regular3Style } from "./css/Regular3Style";
import OutroLogo from "../../components/editor/Templates/OutroLogo";
import OutroText from "../../components/editor/Templates/OutroText";

const regular_3 = (props) => {
  return (
    <Regular3Style>
      <div className="poster flex-column">
        <div className="poster-content">
          <div className="logo-container flex-column">
            <OutroLogo logo={props.file} />
          </div>
          <div className="text-wrapper flex-column">
            <OutroText
              id={props.id}
              text={props.text}
              textStyle={props.textStyle}
              editStatus={props.editStatus}
              onInputSlideText={props.onInputSlideText}
            />
          </div>
        </div>
      </div>
    </Regular3Style>
  );
};

export default regular_3;
